'use strict'

/**
 *
 * @name: nnPostsExpandSwiper
 *
 */

import DirectiveTemplate from './nn-posts-expand-swiper.directive.html'
import './nn-posts-expand-swiper.directive.scss'

function NnPostsExpandSwiperDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      content: '=*',
      analyticsLabel: '=*',
      fetchMethod: '&',
      onAnalyticsClick: '&',
      videoUrl: '&'
    },
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope, $element, $timeout, $rootScope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  $scope.swiperData = null
  $scope.loadingId = null
  $scope.swiperData = null
  $scope.activePost = null

  const transitionDuration = 300
  const swiperEl = $element[0].querySelector('#js-swiper-container')

  let postsCoords = null
  let lastPostEl = null
  let postEl = null
  let allPostsArr = null

  /*
   *
   * @PUBLIC
   *
   */

  $scope.onCloseSwiper = () => {
    $scope.swiperData = null
    $scope.activePost = null
    _resetPostsMargin()
  }

  $scope.toggleSlider = post => {
    if(!postsCoords) {
      allPostsArr = $element[0].querySelectorAll('.js-post')
      _setPostCoords()
    }

    postEl = $element[0].querySelector('#js-post-' + post.id)
    postEl.style.transitionDuration = transitionDuration + 'ms'

    // @fetch data
    if(!post.swiperData) {
      $scope.loadingId = post.id
      $scope.fetchMethod({ post }).then(res => {
        post.swiperData = res
        $scope.loadingId = null
        $scope.toggleSlider(post)
      })
    }

    // @click on same post
    else if ($scope.swiperData && postEl.id === lastPostEl.id) {
      $scope.onCloseSwiper()
    }

    // @click on new post
    else {
      if (lastPostEl && !_isPostInSameRow()) {
        _resetPostsMargin()
      }

      $scope.activePost = post
      swiperEl.style.opacity = 0
      $scope.swiperData = post.swiperData
      $scope.baseSwiper.setUpdate()
      postEl.style.marginBottom = '320px'

      setTimeout(() => {
        swiperEl.style.opacity = 1
        swiperEl.style.top = postsCoords[postEl.id].offsetTop + postsCoords[postEl.id].offsetHeight + 'px'
        _scrollToSwiper(postsCoords[postEl.id].offsetTop)
        lastPostEl = postEl
      }, transitionDuration)
    }
  }


  /*
   *
   * @PRIVATE
   *
   */

  function _scrollToSwiper (swiperTop) {
    window.scroll({
      top: $element.offset().top + swiperTop,
      left: 0,
      behavior: 'smooth'
    })
  }

  function _resetPostsMargin () {
    if(!allPostsArr) {
      return
    }

    allPostsArr.forEach(item => {
      item.style.marginBottom = 0
    })
  }

  function _isPostInSameRow () {
    return postsCoords[lastPostEl.id].offsetTop === postsCoords[postEl.id].offsetTop
  }

  function _setPostCoords () {
    if (!allPostsArr) return;

    const _postsCoords = {}

    allPostsArr.forEach(item => {
      _postsCoords[item.id] = {
        offsetTop: item.offsetTop,
        offsetHeight: item.offsetHeight
      }
    })

    postsCoords = _postsCoords
  }


  /*
   *
   * @INIT
   *
   */

  $scope.$on('ngRepeatFinished', () => {
    if ($scope.baseSwiper) {
      $scope.baseSwiper.setUpdate()
    }
  })

  $rootScope.$watch('$bp', () => {
    $scope.onCloseSwiper()

    $timeout(() => {
      _setPostCoords()
    }, 1000)
  })

}

export default NnPostsExpandSwiperDirective



// WEBPACK FOOTER //
// ./app/components/nn-modules/common-components/nn-posts-expand-swiper/nn-posts-expand-swiper.directive.js